module.exports = __webpack_public_path__ + "img/gongsi.c4d2dc0e.webp";